import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const ContactCard = () => {
  const navigate = useNavigate();
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (document.referrer) {
      navigate("/");
    } else {
      setTimeout(() => setLoaded(true), 100);
    }

    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex";
    document.head.appendChild(meta);

    return () => {
      document.head.removeChild(meta);
    };
  }, [navigate]);

  return (
    <div
      className="min-h-screen flex items-start justify-center px-4 pt-12 pb-6"
      style={{
        background: "linear-gradient(to bottom right, #fbf6f3, #544541)",
        fontFamily: "sans-serif",
      }}
    >
      <div
        className={`w-full max-w-md bg-[#fbf6f3] rounded-3xl shadow-xl px-8 py-10 text-center transition-all duration-700 ease-out ${
          loaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
        }`}
      >
        <img
          src="/Logo.png"
          alt="Simply Sigma Logo"
          className={`w-32 h-32 rounded-full mx-auto mb-6 border-4 border-white shadow animate-fade-in`}
        />

        <h1 className="text-3xl font-bold text-gray-800 mb-1">Jatin Kapoor</h1>
        <p className="text-base text-gray-800 font-medium">
          <span className="font-bold">Founder</span>, Simply Sigma Learning Services
        </p>
        <p className="text-md text-gray-600 mt-1">Ras al Khaimah, United Arab Emirates</p>

        <div className="text-left mt-6 space-y-2 text-md text-gray-700">
          <p><strong>Phone:</strong> +971 559471040</p>
          <p><strong>Email:</strong> jatin.kapoor@simplysigmalearning.com</p>
          <p><strong>Website:</strong> www.simplysigmalearning.com</p>
        </div>

        <a
          href="/JatinKapoor_Contact.vcf"
          download
          className="mt-8 block w-full bg-[#544541] text-white py-3 rounded-xl font-semibold text-base shadow-md hover:scale-[1.02] hover:shadow-lg transition transform duration-300"
        >
          Add to Contacts
        </a>

        <div className="mt-6 flex flex-row flex-wrap justify-center gap-4">
          <a
            href="tel:+971559471040"
            className="px-6 py-2 bg-[#544541] text-white rounded-lg text-base hover:bg-[#6b5e56] transition duration-300 min-w-[100px] text-center"
          >
            Call
          </a>
          <a
            href="https://www.simplysigmalearning.com"
            className="px-6 py-2 bg-[#544541] text-white rounded-lg text-base hover:bg-[#6b5e56] transition duration-300 min-w-[100px] text-center"
          >
            Website
          </a>
          <a
            href="mailto:jatin.kapoor@simplysigmalearning.com"
            className="px-6 py-2 bg-[#544541] text-white rounded-lg text-base hover:bg-[#6b5e56] transition duration-300 min-w-[100px] text-center"
          >
            Email
          </a>
        </div>
      </div>

      <style>{`
        @keyframes fadeInLogo {
          from { opacity: 0; transform: scale(0.8); }
          to { opacity: 1; transform: scale(1); }
        }
        .animate-fade-in {
          animation: fadeInLogo 0.8s ease-out;
        }
      `}</style>
    </div>
  );
};

export default ContactCard;
